// extracted by mini-css-extract-plugin
export default {"skillBlock":"Skill_skillBlock__PytfV","skillImg":"Skill_skillImg__jmJ-B"};